module.exports = __webpack_public_path__ + "img/报名采集模版示例二.d75fe2ac.png";